const BaseURL = "https://sponsa.app";
// const BaseURL = "https://sponsa.validatione.com";

export default BaseURL;
